"use strict";function getPerfInfo$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getPerfInfo$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.getPerfInfo";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.14"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.14"},_a)),exports.getPerfInfo$=getPerfInfo$,exports.default=getPerfInfo$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/getPerfInfo.js
// module id = 1009
// module chunks = 106